import React, { useState, useEffect } from "react";

/**
 * @function UIPhoneInput
 * @param {STRING} className - Additional css class
 * @param {STRING} value - The value that should be set for the text field
 * @param {STRING} placeHolder - The placeholder that should be shown if nothing is in the field
 * @param {FUNCTION} onChange - A function to be ran when the value is updated in the field
 * @returns {React.Component}
 * @example <UIPhoneInput value="(123) 456-1234" onChange={ value => { ... } } />
 */
export default function UIPhoneInput(props) {
    const [ state, setState ] = useState(props.value ?? "");
    const inputField = React.createRef();

    const className = props.className ?? "";
    const dataPoint = props.dataPoint ? { "data-point" : props.dataPoint } : {};
    const onChange = evt => {
        // Get the value from the input field
        let value = inputField.current.value;
        // Remove all characters that aren't a number
        value = value.replace(/[^0-9]/g, "");
        // If the key that was pressed was the delete button
        if(evt.nativeEvent.inputType === "deleteContentBackward") {
            // Use the value set in state (should have the value before the delete was pressed)
            value = state.replace(/[^0-9]/g, "");
            // With all the non number characters removed, remove that last value
            value = value.slice(0, value.length - 1);
        }

        const areaCode = value.substring(0, 3).length > 0 ? `(${ value.substring(0, 3) })` : "";
        const firstThree = value.substring(3, 6).length > 0 ? ` ${ value.substring(3, 6) }` : "";
        const lastFour = value.substring(6, 10).length > 0 ? `-${ value.substring(6, 10) }` : "";
        // Create the phone value and update state
        value = `${ areaCode }${ firstThree }${ lastFour }`;
        setState(value);
        // If the onChange property is a function then run the on change passing the value
        if(props.onChange instanceof Function) {
            props.onChange(value);
        }
    };  
    // If the value set in the props was updated, then update the state with the new value
    useEffect(() => setState(props.value ?? ""), [ props.value ]);

    return (
        <div className={`form-row flex-height uitextinput ${className}`}>
            <div className="floating-label-input-container">
                <input className="floating-label-input form-row-input" ref={ inputField }
                type="text" placeholder=" " value={ state } onChange={ onChange } { ...dataPoint }></input>
                <label className="floating-label form-row-label">{props.placeHolder}</label>
            </div>
            <span className="form-row-info-text gray-text">
                {props.children}
            </span>
        </div>
    );
}